import { useEffect } from "react";

const useTitle = (title) => {
  useEffect(() => {
    document.title = `${title} - Korai`;
  }, [title]);
};

export default useTitle;
